import { AUTOMATION_RULES_API } from 'modules/automation-rules/api/automation-rules-api'
import {
  AutomationRuleViewInterface,
  RuleId,
} from 'modules/automation-rules/types/automation-rule-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { automationRuleDependencies } from '../constants/automation-rule-dependencies'

export function useAutomationRule(id: RuleId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleViewInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(() => {
    if (user) {
      return [`${AUTOMATION_RULES_API}/${id}`, ...automationRuleDependencies]
    }
    return null
  }, fetcher)
}
